export default [
  {
    key: 'id',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    label: 'アライアンス名',
    key: 'company',
    _style: 'min-width:140px',
  },
  {
    label: 'マネージャID',
    key: 'admin_name',
    _style: 'min-width:140px',
    slot: true,
  },
  {
    label: 'マネージャ名',
    key: 'admin_display_name',
    _style: 'min-width:140px;',
  },
  { label: 'マネージャタイプ', key: 'level', _style: 'min-width:140px;' },
  { label: '最終ログインIP', key: 'login_ip', _style: 'min-width:140px;' },
  { label: '最終ログイン日時', key: 'login_time', _style: 'min-width:140px;' },
  { label: '登録日時', key: 'created_at', _style: 'min-width:140px;' },
  { label: '更新日時', key: 'updated_at', _style: 'min-width:140px;' },
]
